import FadingAnimation from './fading-animation'

/*
 * This animation is used when a bar is being split up into a stacked bar
 *
 * For example, a bar is showing total sales, but then is split into a stack based on products
 */
class AddInnerStackAnimation extends FadingAnimation {

  constructor (options) {
    super(options)
    this.twoPart = true
    this.ripple = true
  }

  match (serie) {
    if (!this.chart.previous) {
      return false
    }

    let exitingSeries = this.exitingSeries.selection().data()
      , seriesAtExitingColumn = exitingSeries.length == 1 && this.series.filter(serie => serie._columnIdx == exitingSeries[0]._columnIdx)

    return this.seriesChanged &&
           this.chart.previous.layout && // this is an update, not a fresh render
           this.chart.layout.columnCount() == this.chart.previous.layout.columnCount() && // Same number of columns
           this.exitingSeries.size() === 1 && // A single serie is exiting
           seriesAtExitingColumn.size() && // There are 1 or more series at the exiting column
           seriesAtExitingColumn.selection().data()[0].stackBy && // The series at the entering column are stacked
           !exitingSeries[0].stackBy // Previously serie that's being removed wasn't stacked
  }

}

export default AddInnerStackAnimation
